export function EmptyInspector() {
  return (
    <div className="text-muted-foreground rounded-xl border p-4 text-sm">Select a field from the schema tree.</div>
  );
}
